import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { ThemeProvider } from "./ThemeContext";
import { AuthProvider } from "./AuthContext";
import Navbar from "./Navbar";
import Footer from "./Footer";
import BackToTop from "./components/BackToTop";
import ProtectedRoute from "./ProtectedRoute";
import LoginModal from "./components/LoginModal";

import Home from "./Home";
import Cart from "./Cart";
import Checkout from "./Checkout";
import Products from "./Products";
import MyOrders from "./MyOrders";
import Login from "./Login";
import AdminDashboard from "./AdminDashboard";
import AdminOrders from "./AdminOrders";
import OrderConfirmation from "./OrderConfirmation";
import AboutUs from "./AboutUs";
import Contact from "./Contact";
import FAQ from "./FAQ";
import PrivacyPolicy from "./PrivacyPolicy";
import TermsOfService from "./TermsOfService";
import Shipping from "./Shipping";
import Returns from './Returns';
import DietaryInfo from "./DietaryInfo";
import { useTranslation } from "react-i18next";
import "./index.css";

function App() {
  const { i18n } = useTranslation();

  // Set lang attribute on <html> for accessibility and SEO
  useEffect(() => {
    document.documentElement.lang = i18n.language || 'en';
  }, [i18n.language]);

  return (
    <ThemeProvider>
      <AuthProvider>
        <Router>
          <div className="min-h-screen flex flex-col bg-raya-bg text-raya-text-primary transition-colors duration-300">
            <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-[60] focus:px-4 focus:py-2 focus:bg-raya-accent focus:text-black focus:rounded-lg focus:font-semibold">
              Skip to content
            </a>
            <Toaster position="top-right" toastOptions={{
              style: {
                background: '#1a1a1a',
                color: '#f3f4f6',
                border: '1px solid #d4af37',
              },
            }} />
            <Navbar />
            <LoginModal />
            <main id="main-content" className="flex-grow container mx-auto px-4 py-8 relative z-0 mt-16">
              <Routes>
                <Route path="/login" element={<Login />} />
                
                <Route path="/" element={<Home />} />
                <Route path="/products" element={<Products />} />
                <Route path="/cart" element={<Cart />} />
                
                {/* Protected Routes */}
                <Route
                  path="/checkout"
                  element={
                    <ProtectedRoute>
                      <Checkout />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/order-confirmation"
                  element={
                    <ProtectedRoute>
                      <OrderConfirmation />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/my-orders"
                  element={
                    <ProtectedRoute>
                      <MyOrders />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/admin"
                  element={
                    <ProtectedRoute adminOnly={true}>
                      <AdminDashboard />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/admin/orders"
                  element={
                    <ProtectedRoute adminOnly={true}>
                      <AdminOrders />
                    </ProtectedRoute>
                  }
                />
                
                {/* Footer Pages - Public */}
                <Route path="/about" element={<AboutUs />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/faq" element={<FAQ />} />
                <Route path="/privacy" element={<PrivacyPolicy />} />
                <Route path="/terms" element={<TermsOfService />} />
                <Route path="/shipping" element={<Shipping />} />
                <Route path="/returns" element={<Returns />} />
                <Route path="/dietary-info" element={<DietaryInfo />} />
              </Routes>
            </main>
            <Footer />
            <BackToTop />
          </div>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
